<section class="section_wrapper">
    <div id="summaryUpstairs"class="summary_title" *ngIf="showMainContent">
        <h1>Join 360</h1>
        <img src="./assets/contact/line.svg" alt="blue line">
        <h3>Key Metrics at a Glance</h3>
    </div>
    <div class="main_content">
        <div class="task_table" *ngIf="showMainContent">
            <div class="first_line">
                <div class="table_cell more_padding" (click)="navigateToDetailWithFragment('toDoSection')">
                    <img class="todo_icon" src="./assets/summary/to_do_icon.svg" alt="to do task icon">
                    <div>
                        <span class="count">{{ getTodoTaskCount() }}</span>
                        <p>To-do</p>
                    </div>
                    
                </div>
                <div class="table_cell more_padding" (click)="navigateToDetailWithFragment('doneSection')">
                    <img class="done_icon" src="./assets/summary/done_icon.svg" alt="done task icon">
                    <div>
                        <span class="count">{{ getDoneTasksCount() }}</span>
                        <p>Done</p>
                    </div>
                </div>
            </div>

            <div class="urgent_task" (click)="navigateToBoardView()">
                <div class="task_count">
                    <img class="urgent_icon" src="./assets/summary/urgent_icon.svg" alt="urgent task icon">
                    <div>
                        <span class="count">{{ getUrgentTaskCount() }}</span>
                        <p>Urgent</p>
                    </div>
                </div>
                <img class="divider" src="./assets/summary/grey_dividing_line.svg" alt="grey line">
                <div class="due_date">
                    <p class="task_date">{{ getUrgentTaskWithLowestDate() }}</p>
                    <p>Upcoming Deadline</p>
                </div>
            </div>

            <div class="third_line">
                <div class="table_cell" (click)="navigateToBoardView()">
                    <div>
                        <span class="count">{{ getAllTaskCount() }}</span>
                        <p>Tasks in<br>Board</p>
                    </div>
                </div>
                <div class="table_cell" (click)="navigateToDetailWithFragment('inProgressSection')">
                    <div>
                        <span class="count">{{ getInProgressTaskCount() }}</span>
                        <p>Tasks in<br>Progress</p>
                    </div>
                </div>
                <div class="table_cell" (click)="navigateToDetailWithFragment('awaitFeedbackSection')">
                    <div>
                        <span class="count">{{ getAwaitFeedbackTaskCount() }}</span>
                        <p>Awaiting<br>Feedback</p>
                    </div>
                </div>
            </div>
        </div>
        @if (currentUser?.displayName == 'guest' && showGreeting) {
            <div class="welcome">
                <span class="greeting" id="guestGreeting">{{ getGreeting() }}</span>
            </div>
        }
        @else if (showGreeting && currentUser?.displayName !== 'guest' && showGreeting) {
            <div class="welcome">
                <span class="greeting">{{ getGreeting() }},</span>
                <span class="user_name">{{ usersFullName | titlecase}}</span>
            </div>
        }
    </div>
</section>
